import { defineStore } from 'pinia';

export const usePhonePromptStore = defineStore('phonePromptStore', {
  state: () => ({
    visible: false,
    // Identifier of the event/source that triggered the prompt – used to debounce repeated prompts during the same session.
    promptedSources: new Set<string>(),
  }),
  actions: {
    /**
     * Open the phone prompt. If `source` is provided, the prompt will be shown
     * only once per source (e.g. once per event registration), so the user
     * isn't pestered repeatedly when toggling registration.
     */
    open(source?: string) {
      if (source) {
        if (this.promptedSources.has(source)) return;
        this.promptedSources.add(source);
      }
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
  },
});
